import { Box} from "@chakra-ui/react";
import PrivateContentLayout from "../Common/PrivateContentLayout";
import ChangePassword from "../Common/ChangePassword";
import TutorSideBar from "../Components/TutorSideBar";


interface ChangePasswordProps {
  handleLogout: () => void; // Pass the handleLogout function as a prop
}

const ChangePasswordTutor = ({ handleLogout }: ChangePasswordProps) => {
  
  return (
   
    <Box>
        <TutorSideBar />
        <PrivateContentLayout>
        <ChangePassword handleLogout={handleLogout} />
        </PrivateContentLayout>
    </Box>
  );
};

export default ChangePasswordTutor;
